import { useMemo } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import styles from "./ButtonGroup.module.scss";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";

const ButtonGroup = ({ options, value, onChange }) => {
	const groupStyle = useMemo(
		() => ({
			"--active-index": `${options.findIndex(option => option.value === value)}`,
			"--button-count": `${options.length}`,
		}),
		[options, value]
	);

	return (
		<div className={styles["button-group"]} style={groupStyle}>
			{options.map(option => (
				<button
					key={option.value}
					type="button"
					data-testid="button-group-item"
					aria-pressed={option.value === value}
					className={classNames(styles["button-group__item"], {
						[styles["button-group__item--active"]]: option.value === value,
					})}
					onClick={() => onChange(option.value)}
				>
					<Typography variant={TYPOGRAPHY_VARIANTS.SMALL} isBold>
						{option.label}
					</Typography>
				</button>
			))}
		</div>
	);
};

ButtonGroup.propTypes = {
	options: PropTypes.arrayOf(
		PropTypes.shape({
			value: PropTypes.string.isRequired,
			label: PropTypes.string.isRequired,
		})
	).isRequired,
	value: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
};

export default ButtonGroup;
